import { DataProvider } from "ra-core/esm/types"

const dataProvider: DataProvider = (type, resource, params) => {
    return Promise.reject("Unknown method")
}

export default dataProvider
